import type { FaireProductEntity } from "../../entity_types/product";

export const p_hcw67rep79: FaireProductEntity = {
  token: "p_hcw67rep79",
  type: "product",
  name: 'Pnk/Blu Rustic Style Mug-4"H(14oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/54617f062312e244feec134bc363f1b7b706780cb093f7253c85abe9ffefebf5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf8c52648067bcb8195ded27840e3f5f74b9bc9676f3e8fc7826708aa3e23d95.jpeg",
    "https://cdn.faire.com/fastly/eb68f7bbc381e28fb440f501cd21dea78f70d20e8460565c9626287f6a2353ca.jpeg",
    "https://cdn.faire.com/fastly/5916c67e9ac714e8cc8d87856549936a031051ee454c7c9abb8088ca5f51509e.jpeg",
    "https://cdn.faire.com/fastly/bb0f507cbf45e54fbf30a126d85844952cbf8f84d12341b1d0a7fe8f7e8ebee4.jpeg",
    "https://cdn.faire.com/fastly/dadad961f229f3909b75b425302b357c45424950dfb6ae09d1588a1dced5500d.jpeg",
  ],
  priceDollars: 8,
  description:
    "Add a fashion-forward touch to your kitchenware with this retro-chic Rustic Style Mug. Crafted out of stoneware, this pink-and-blue mug features a wide base for spacious 14 oz. capacity — complemented by its simple yet striking design and vintage charm. Other colours also available.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:10.009Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
